/**
 * Authentication configuration file
 */

const authConfig = {
  // API configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL,
  
  // Authentication endpoints
  AUTH_ENDPOINT: '/api/auth/session',
  LOGIN_ENDPOINT: '/api/auth/login',
  LOGOUT_ENDPOINT: '/api/auth/logout',
  PERMISSIONS_ENDPOINT: '/api/auth/permissions',
  
  // Default token to use if none is set (development only)
  DEFAULT_AUTH_TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
  
  // Token storage key
  TOKEN_STORAGE_KEY: 'session_id',
  
  // Redirect URL after logout
  REDIRECT_URL: '/login',
  
  // Session configuration
  SESSION_EXPIRY: 6 * 60 * 60 * 1000, // 6 hours in milliseconds
  
  // Permission-to-description mapping for UI display
  PERMISSION_DESCRIPTIONS: {
    'VIEW_DASHBOARD': 'Access to main dashboard view',
    'VIEW_HOSTS': 'Access to hosts monitoring data',
    'VIEW_CLIENTS': 'Access to client data',
    'VIEW_ALERTS': 'Access to security alerts',
    'VIEW_OCI_COSTS': 'Access to OCI cost data',
    'VIEW_OCI_INSTANCES': 'Access to OCI instance data',
    'VIEW_OCI_STORAGE': 'Access to OCI storage data',
    'VIEW_OCI_DASHBOARD': 'Access to OCI dashboard and overview',
    'MANAGE_ALERTS': 'Create and manage alerts',
    'MANAGE_USERS': 'Create and manage user accounts'
  },
  
  // Role color mapping for UI display
  ROLE_COLORS: {
    'admin': 'error',
    'finance': 'success',
    'soc': 'warning',
    'rd': 'info',
    'sales': 'primary',
    'user': 'default'
  }
};

export default authConfig;